import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const createHolderSubaccount = (investor_id, account_name) => request.post(`${API_BASE_URL}/blockchain/holder/sub-accounts`, {
    investor_id,
    account_name
})

export default createHolderSubaccount